import { render, staticRenderFns } from "./FormUserData.vue?vue&type=template&id=0a6c5b84&scoped=true&"
import script from "./FormUserData.vue?vue&type=script&lang=js&"
export * from "./FormUserData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c5b84",
  null
  
)

export default component.exports